import { api } from '@/lib/api/client';

/**
 * Caso 09 — Demographic aggregation, bucketed counts. Mirrors
 * `DemographicsAggregate` from ox-platform/src/apps/console/services/
 * demographics.service.ts.
 */
export interface DemographicsAggregate {
  total: number;
  ageRange: Record<string, number>;
  gender: Record<string, number>;
  ethnicity: Record<string, number>;
  city: Record<string, number>;
  state: Record<string, number>;
  language: Record<string, number>;
}

export const demographicsApi = {
  byEvent: (eventId: number) =>
    api.get<DemographicsAggregate>(`/co-contacts/demographics`, {
      params: { eventId },
    }),

  workspace: () => api.get<DemographicsAggregate>(`/co-contacts/demographics`),
};
